// src/services/BehavioralLogsService.js
// Analytics pédagogiques — collection distincte de appLogs (erreurs techniques).
// userId réel (non haché) pour corrélation prof-élève.
// Pas de déduplication : chaque événement est unique.
import { getSessionId } from '../utils/sessionId';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebaseConfig';

const IS_PROD = process.env.NODE_ENV === 'production';

async function log(type, userId, params = {}) {
  if (!IS_PROD) return;
  if (!userId) return;

  try {
    await addDoc(collection(db, 'behavioralLogs'), {
      type,
      userId,
      ...params,
      sessionId: getSessionId(),
      timestamp: Timestamp.now(),
    });
  } catch {
    // Fail silently — ne jamais casser l'app
  }
}

const BehavioralLogsService = {
  // XP attribués — les deux chemins (standard via saveExerciseProgress, direct via addXP)
  // xpServer : valeur recalculée côté CF (null si non disponible)
  xpTransaction: (userId, params) => log('xp_transaction', userId, params),

  // Erreur pendant un exercice : wrong_note, missing_in_chord, extra_note, timing_miss, generic
  exerciseError: (userId, params) => log('exercise_error', userId, params),

  // Élève a quitté l'exercice avant la fin
  exerciseAbandon: (userId, params) => log('exercise_abandon', userId, params),

  // Distribution des erreurs par temps (beat 1-4) à la fin d'une session
  beatHeatmap: (userId, params) => log('beat_heatmap', userId, params),

  // Delta (ms) entre deux notes d'un accord joué dans la fenêtre 50ms
  chordTiming: (userId, params) => log('chord_timing', userId, params),

  // Notes arrivées entre 50ms et 120ms — accord manqué de peu
  chordNearMiss: (userId, params) => log('chord_near_miss', userId, params),

  // Périphérique MIDI connecté (loggué une fois par session)
  midiDevice: (userId, params) => log('midi_device', userId, params),

  // Résultat d'un exercice terminé (réussi ou non) : sert à mesurer la difficulté par exercice
  exerciseResult: (userId, params) => log('exercise_result', userId, params),
};

export default BehavioralLogsService;
